/**
 * 系统管理 用户管理
 */
<template>
  <div>
    
    <p>邀请列表</p>

    <!--列表-->
    <el-table size="small" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;margin-top: 30px;">
      <!-- normal:普通用户,holder矿机主，primary股东，partner 合伙人 -->
      <!-- <el-table-column align="center" prop="userType" label="身份类型" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.userType == 'normal'">普通用户</div>
          <div v-if="scope.row.userType == 'holder'">矿机主</div>
          <div v-if="scope.row.userType == 'primary'">股东</div>
          <div v-if="scope.row.userType == 'partner'">合伙人</div>
        </template>
      </el-table-column> -->
      <el-table-column align="center" prop="userName" label="用户名" >
      </el-table-column>
      <!-- <el-table-column align="center" prop="inviteCode" label="邀请码" >
      </el-table-column> -->
      <el-table-column align="center"  prop="setupTime" label="注册时间" >
        <template slot-scope="scope">
          <div>{{scope.row.setupTime}}</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
// 导入请求方法
import {
  userInvitList
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      // 请求数据参数
      formInline: {
        from: 1,
        limit: 10,
        uId: null,
      },
      //用户数据
      userData: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  props:['code'],
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 创建完毕
   */
  created() {
    // console.log(this.$props.code)
    // alert(111)
    this.formInline.uId = parseInt(this.$props.code) 
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      // 获取用户列表
      userInvitList(parameter).then(res => {
        this.loading = false
        if (res.code != 0) {
          this.$message({
            type: 'info',
            message: res.message
          })
        } else {
          this.userData = res.data.list
          // 分页赋值
          // this.pageparm.currentPage = this.formInline.from
          // this.pageparm.pageSize = this.formInline.limit
          this.pageparm.total = res.data.total
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm)
      this.pageparm.pageSize = parm.pageSize
      this.formInline.from = (parm.currentPage-1)*(this.pageparm.pageSize) + 1
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    }

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/system/Invit.vue